import styled, { keyframes } from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
// @ts-ignore
import { TextField } from '@netbasequid/core'
import { ScrollbarStyle } from 'styles'

export const StyledFormContainer = styled.div<{ paddings: string | undefined; disable: boolean }>`
  padding: ${({ paddings }) => paddings || '8px 0'};
  opacity: ${({ disable }) => (disable ? 0.4 : 1)};
  pointer-events: ${({ disable }) => (disable ? 'none' : 'auto')};
`

export const StyledForm = styled.form`
  display: grid;
  grid-template-columns: max-content minmax(0px, 1fr);
  grid-template-rows: auto auto;
  gap: 16px 12px;
`

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const StyledLogo = styled.div`
  margin-top: 8px;
  transform-origin: 8px 8px;
  animation: ${rotateAnimation} 1s linear infinite;
`

export const StyledLoadingField = styled.div<{ mode: Theme }>`
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  border: 1px solid ${({ mode }) => sys[mode].interaction.border.default};
  border-radius: 2px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ mode }) => sys[mode].text.placeholder};
`

export const StyledReportLinkField = styled(TextField)`
  pointer-events: none;
  cursor: not-allowed;
`

export const StyledLabel = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  font-size: ${sys.typescale[14].size};
  font-weight: ${sys.fontWeight.medium};
  line-height: ${sys.typescale[14].lineHeight};
`

export const StyledReportKeyLabel = styled(StyledLabel)`
  display: flex;
  height: 32px;
`

export const StyledActionsContainer = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`

export const StyledReportKeyArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledReportKeyValidationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
`

export const StyledReportKeyValidationItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const StyledSubscribersLabel = styled(StyledLabel)`
  display: flex;
  height: 32px;
`

export const StyledSubscribersArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledSubscribersListContainer = styled.div<{ $mode: Theme }>`
  height: 160px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border: 1px solid ${({ $mode }) => sys[$mode].interaction.border.default};
  border-radius: 2px;
  cursor: default;
  overflow: auto;
  ${ScrollbarStyle}
`

export const StyledLoadingList = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledSubscribersListItem = styled.div<{ mode: Theme }>`
  height: 34px;
  box-sizing: border-box;
  padding: 6px 11px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  font-size: ${sys.typescale[14].size};
  font-weight: ${sys.fontWeight.regular};
  line-height: ${sys.typescale[14].lineHeight};
  border-bottom: 1px solid ${({ mode }) => sys[mode].common.divider[100]};
  &:hover {
    background-color: ${({ mode }) => sys[mode].interaction.onElevation.default};
  }
`

export const StyledSubscribersEmail = styled.div`
  flex: 1;
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StyledSubscribersHint = styled.div<{ mode: Theme }>`
  height: 100%;
  font-size: ${sys.typescale[14].size};
  font-weight: ${sys.fontWeight.regular};
  line-height: ${sys.typescale[14].lineHeight};
  color: ${({ mode }) => sys[mode].text.placeholder};
`

export const StyledReminderContainer = styled.div<{ disable: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 8px 0;
  opacity: ${({ disable }) => (disable ? 0.4 : 1)};
  pointer-events: ${({ disable }) => (disable ? 'none' : 'auto')};
`

export const StyledReminder = styled.div<{ mode: Theme }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  color: ${({ mode }) => sys[mode].text.placeholder};
  font-size: ${sys.typescale[12].size};
  font-weight: ${sys.fontWeight.regular};
  line-height: ${sys.typescale[12].lineHeight};
`

export const StyledLimitedDashboardReminder = styled(StyledReminder)`
  align-items: flex-start;
`

export const StyledReminderIconContainer = styled.div`
  width: 14px;
  display: flex;
  align-items: center;
`
